import { Answer } from '../../atoms/Answer';
import { Typography } from '../Typography';

export interface AnswerType {
  area: string;
  correct: true | false | undefined;
  exerciseType: string;
  done: boolean;
  selected?: boolean;
  hasAlternativeSelected?: boolean;
  position?: number | undefined;
  id?: string;
}

interface AnswersHolderProps {
  title?: string;
  answers: AnswerType[];
  isAnswerSheet?: boolean;
  onSelectedAnswer?: (index: number) => void;
  onSelectQuestion?: (index: string) => void;
}

function AnswersHolder({
  title,
  answers,
  isAnswerSheet = false,
  onSelectedAnswer,
  onSelectQuestion,
}: AnswersHolderProps) {
  return (
    <div className='flex flex-col items-start gap-md'>
      {title !== '' && <Typography>{title}</Typography>}
      <div
        className={
          isAnswerSheet
            ? // No cartao resposta o mobile fica travado em 5 questoes por
              // linha, ocupando toda a largura disponivel: cada botao acompanha
              // a coluna do grid.
              'grid w-full grid-cols-5 gap-sm md:flex md:flex-wrap'
            : 'flex flex-wrap gap-sm'
        }
      >
        {answers.map((answer, index) => (
          <Answer
            key={index}
            className={isAnswerSheet ? 'w-full md:w-11' : undefined}
            number={answer.position || index + 1}
            selected={answer.selected}
            variant={
              answer.exerciseType === 'discursive'
                ? 'discursive'
                : answer.correct && answer.done
                ? 'correct'
                : answer.correct === false && answer.done
                ? 'incorrect'
                : isAnswerSheet && answer.hasAlternativeSelected
                ? 'selected'
                : 'undefined'
            }
            done={answer.done}
            onClick={() => {
              onSelectQuestion
                ? onSelectQuestion(answer.id || index.toString())
                : '';
              onSelectedAnswer ? onSelectedAnswer(index) : '';
            }}
          />
        ))}
      </div>
    </div>
  );
}

export { AnswersHolder };
